import { render, staticRenderFns } from "./ReportNavigation.vue?vue&type=template&id=53ba3004&"
import script from "./ReportNavigation.vue?vue&type=script&lang=js&"
export * from "./ReportNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ba3004')) {
      api.createRecord('53ba3004', component.options)
    } else {
      api.reload('53ba3004', component.options)
    }
    module.hot.accept("./ReportNavigation.vue?vue&type=template&id=53ba3004&", function () {
      api.rerender('53ba3004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/ReportNavigation.vue"
export default component.exports